import { FiEdit2, FiTrash2 } from 'react-icons/fi';
import Switch from 'components/shared/Switch';
import { deletePlan } from 'api/plans';

interface Plan {
    id: string;
    name: string;
    description: string;
    isActive: boolean;
    permissions?: string[];
    createdAt?: string;
}

interface PlansTableProps { 
    plans: Plan[];
    onUpdatePlan: (plan: Plan) => void;
    onEdit: (plan: Plan) => void;
    fetchPlans?: () => void;
}

export default function PlansTable({ plans, onUpdatePlan, onEdit, fetchPlans }: PlansTableProps) {
    const handleEdit = (plan: Plan) => {
        onEdit(plan);
    };

    const handleToggleStatus = (plan: Plan) => {
        onUpdatePlan({
            ...plan,
            isActive: !plan.isActive
        });
    };

    const handleDelete = async (plan: Plan) => {
        // Handle delete
       const response = await deletePlan(plan.id);
       if(response.status === 200){
        fetchPlans?.();
       }else{
        console.log("Error:", response?.data?.message);
       }
    };

    return (
        <div className="">
        <div className="sticky top-[160px] bg-black z-10 pt-4">
            <div className="bg-[#2A2A2A] rounded-lg overflow-hidden">
                <table className="w-full table-fixed">
                    <thead>
                            <tr className="bg-[#1A1A1A] text-gray-400 text-sm">
                                <th className="text-left py-3 px-4 w-[11%]">Plan Name</th>
                                <th className="text-left py-3 px-4 w-[11%]">Description</th>
                                <th className="text-center py-3 px-4 w-[11%]">Status</th>
                                <th className="text-right py-3 px-4 w-[11%]">Action</th>
                            </tr>
                        </thead>
                </table>
            </div>
            </div>

            <div className="bg-[#2A2A2A] rounded-lg overflow-hidden">
                <div className="">
                    <table className="w-full  table-fixed">
                
                        <tbody>
                            {plans.map((plan) => (
                                <tr 
                                    key={plan.id} 
                                    className="border-b border-white/[0.08] hover:bg-[#3a3a3a33]"
                                >
                                    <td className="py-3 px-4 w-[11%]">
                                        <span className="text-white">{plan.name}</span>
                                    </td>
                                    <td className="py-3 px-4 text-gray-400 max-w-xl w-[11%]">
                                        <span className="line-clamp-1">{plan.description}</span>
                                    </td>
                                    <td className="py-3 px-4 w-[11%]">
                                        <div className="flex justify-center">
                                            <Switch
                                                checked={plan.isActive}
                                                onChange={() => handleToggleStatus(plan)}
                                            />
                                        </div>
                                    </td>
                                    <td className="py-3 px-4 text-right w-[11%]">
                                        <div className="flex items-center justify-end gap-2">
                                            <button 
                                                onClick={() => handleEdit(plan)}
                                                className="p-2 hover:bg-white/[0.08] rounded-lg text-gray-400 hover:text-white"
                                            >
                                                <FiEdit2 size={16} />
                                            </button>
                                            <button 
                                                onClick={() => handleDelete(plan)}
                                                className="p-2 hover:bg-white/[0.08] rounded-lg text-gray-400 hover:text-red-400"
                                            >
                                                <FiTrash2 size={16} />
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
} 